import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/base/ScrollToTop";
import SchemaOrg from "@/components/base/SchemaOrg";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import ArticlesSection from "./components/ArticlesSection";
import StatsSection from "./components/StatsSection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";

const organizationSchema = {
  name: "海角千万资源原创",
  url: "https://www.haijiao-resource.com",
  description: "专注于海量原创内容资源的聚合平台，涵盖图文、视频、创意素材等多元类型，为创作者与企业提供高质量、可信赖的正版原创资源。",
  address: {
    "@type": "PostalAddress",
    addressCountry: "CN",
  },
  sameAs: [],
};

const websiteSchema = {
  name: "海角千万资源原创",
  url: "https://www.haijiao-resource.com",
  description: "海量原创图文素材、原创视频资源聚合，千万正版素材库。",
  inLanguage: "zh-CN",
};

const faqSchema = {
  mainEntity: [
    {
      "@type": "Question",
      name: "海角千万资源原创平台上的内容可以免费使用吗？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "平台提供免费和付费两种授权模式。免费素材在标注来源的前提下可用于个人和非商业用途；付费素材提供完整的商业授权。"
      }
    },
    {
      "@type": "Question",
      name: "如何确保平台内容的原创性和版权合规？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "我们建立了严格的原创审核机制。所有上传内容均经过AI初筛和人工复审双重校验，确保内容的原创性。"
      }
    },
    {
      "@type": "Question",
      name: "平台支持哪些类型的素材格式？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "目前平台支持的素材格式包括：图片类（JPG、PNG、WEBP、PSD、AI）、视频类（MP4、MOV、AVI）、文档类（PDF、PPTX、DOCX）、设计源文件等。"
      }
    },
    {
      "@type": "Question",
      name: "企业用户如何定制专属资源库？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "企业用户可以联系商务团队，开通企业版服务。企业版支持品牌专属素材库搭建、团队协作管理、API接口对接等功能。"
      }
    },
    {
      "@type": "Question",
      name: "平台的内容更新频率如何？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "平台每日新增超过500件原创内容资源。与超过2000位认证创作者保持长期合作，确保资源的持续丰富和更新。"
      }
    },
    {
      "@type": "Question",
      name: "如果发现侵权内容应该如何处理？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "我们高度重视知识产权保护。可通过举报功能或联系客服反馈，承诺24小时内响应并启动调查流程。"
      }
    },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="Organization" data={organizationSchema as Record<string, unknown>} />
      <SchemaOrg type="WebSite" data={websiteSchema as Record<string, unknown>} />
      <SchemaOrg type="FAQPage" data={faqSchema as Record<string, unknown>} />
      <SchemaOrg type="WebPage" data={{ name: "海角千万资源原创——正版内容聚合平台", url: "https://www.haijiao-resource.com/" }} />

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <ArticlesSection />
        <StatsSection />
        <FaqSection />
        <CtaSection />
      </main>

      <Footer />
    </>
  );
}